
export default {
  props: {
    item: Object
  }
};
